import * as React from 'react';
import { faTools } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const CompanyName = () =>
    (<div className="company-name"> Орёл57 {<FontAwesomeIcon icon={faTools} />} Ремонт </div>);